export const setPerPage = (perPage: number): void => {
  localStorage.setItem('perPage', `${perPage}`);
};

const perPageStorage = localStorage.getItem('perPage');
export const perPage = perPageStorage ? Number(perPageStorage) : 10;
